module.exports = __webpack_public_path__ + "static/media/portfolio.05b42604.svg";